import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-ges',
    templateUrl: './ges.component.html',
    styleUrls: ['./ges.component.scss']
})
export class GesComponent {

    constructor(public dialogRef: MatDialogRef<GesComponent>) {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
